import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";

export default function Navbar() {
  const navigate = useNavigate();
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 40);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <nav
      className="fixed top-0 left-0 right-0 z-50 flex items-center justify-between px-8 py-4 transition-all duration-500"
      style={{
        background: scrolled
          ? "rgba(6,8,15,0.92)"
          : "transparent",
        backdropFilter: scrolled ? "blur(20px)" : "none",
        borderBottom: scrolled ? "1px solid rgba(82,198,168,0.1)" : "none",
      }}
    >
      {/* Logo */}
      <div className="flex items-center gap-3">
        <div
          className="w-8 h-8 rounded-lg flex items-center justify-center"
          style={{ background: "linear-gradient(135deg, #52c6a8, #4f8ef7)", boxShadow: "0 0 20px rgba(82,198,168,0.4)" }}
        >
          <span className="font-syne font-bold text-white text-sm">C</span>
        </div>
        <span className="font-syne font-bold text-white text-xl tracking-tight">CAHEX</span>
      </div>

      {/* Links */}
      <div className="hidden md:flex items-center gap-1 px-2 py-1 rounded-full"
        style={{ background: "rgba(255,255,255,0.04)", border: "1px solid rgba(255,255,255,0.07)" }}>
        {["API", "Use Cases", "About Us"].map((item) => (
          <button
            key={item}
            className="px-5 py-2 rounded-full text-sm font-medium transition-all duration-200 hover:text-white"
            style={{ color: "var(--c-muted)", fontFamily: "'DM Sans', sans-serif" }}
            onMouseEnter={e => { e.currentTarget.style.background = "rgba(255,255,255,0.06)"; e.currentTarget.style.color = "#e8eaf0"; }}
            onMouseLeave={e => { e.currentTarget.style.background = "transparent"; e.currentTarget.style.color = "var(--c-muted)"; }}
          >
            {item}
          </button>
        ))}
      </div>

      {/* CTA */}
      <button
        onClick={() => navigate("/merchant/signin")}
        className="px-5 py-2 rounded-full text-sm font-semibold transition-all duration-300 font-syne"
        style={{
          background: "linear-gradient(135deg, #52c6a8, #4f8ef7)",
          color: "#06080f",
          boxShadow: "0 0 20px rgba(82,198,168,0.25)",
        }}
        onMouseEnter={e => { e.currentTarget.style.boxShadow = "0 0 35px rgba(82,198,168,0.5)"; e.currentTarget.style.transform = "scale(1.03)"; }}
        onMouseLeave={e => { e.currentTarget.style.boxShadow = "0 0 20px rgba(82,198,168,0.25)"; e.currentTarget.style.transform = "scale(1)"; }}
      >
        Get Started →
      </button>
    </nav>
  );
}
